import { MultiSetSubTreeBuilder } from "../../General/Tree/MultiSet/multi-set-sub-tree-builder";
import { Node } from "../../General/graph/lib/node";
import { MultiSetTreeNode } from "../../General/Tree/MultiSet/multi-set-tree-node";

export class SubTreeWords extends MultiSetSubTreeBuilder {
    protected activ: boolean = false;
    subNodeMode: boolean = false;
    hideContentMode: boolean = false;
    deleteNodeMode: boolean = false;
    markingMode: boolean = false;


    cachedDeletedContent: any[][] = [];


    getMarkedNodes(): any[][] {
        let content: any[][] = [];
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (node.isSelected()) {
                    content.push(node.getContent());
                }
            }
        })
        return content;
    }

    setMarkedMode(content: any[][]) {
        content.forEach(c => {
            this.nodes.forEach(node => {
                if (node instanceof MultiSetTreeNode) {
                    if (this.equalContent(node.getContent(), c)) {
                        node.selected();
                    }
                }
            })
        })
    }

    setHiddenNodes(content: any[][]) {
        content.forEach(c => {
            this.nodes.forEach(node => {
                if (node instanceof MultiSetTreeNode) {
                    if (this.equalContent(node.getContent(), c)) {
                        node.setHidden(true);
                    }
                }
            })
        })
    }

    getRoot(): MultiSetTreeNode {
        return this.root;
    }

    getHiddenNodes(): any[][] {
        let content: any[][] = [];
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (node.isHidden()) {
                    content.push(node.getContent());
                }
            }
        })
        return content;
    }

    deleteNode(delNode: Node) {
        if (delNode == null)
            return;

        let childrenToRemove: Node[] = [delNode];
        while (childrenToRemove.length > 0) {
            let parent: Node = childrenToRemove.shift();
            parent.getNeighbors().forEach(neighbor => {
                childrenToRemove.push(neighbor);
            });
            if (parent instanceof MultiSetTreeNode) {
                this.cachedDeletedContent.push(parent.getContent());
                super.deleteNode(parent);
            }
        }
        this.update();
    }

    setDeletedNodes(contents: any[][]) {
        contents.forEach(c => {
            this.nodes.forEach(node => {
                if (node instanceof MultiSetTreeNode) {
                    if (this.equalContent(node.getContent(), c)) {
                        this.deleteNode(node);
                    }
                }
            })
        })
    }



    getDeletedNodes(): any[][] {
        return this.cachedDeletedContent;
    }

    disable() {
        this.activ = false;
    }
    enable() {
        this.activ = true;
    }
    doubleClick() {
        return;
    }
    keyboardEvent() { }

    leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        return;
    }

    update() {
        if (this.activ) {
            super.update();
        }
    }
    rightClick() {

    }

    resetModes(){
        this.hideContentMode = false;
        this.deleteNodeMode = false;
        this.markingMode = false;
        this.subNodeMode = false;
    }

    equalContent(content1: any[], content2: any[]): boolean {
        if (content1 == null || content2 == null) {
            return false;
        }
        if (content1.length != content2.length) {
            return false;
        }

        for (let i = 0; i < content1.length; i++) {
            if (!(content1[i] == content2[i])) {
                return false;
            }
        }
        return true;
    }
}
